import { LAYOUTS, POSITION, } from '@voltmoney/types';
import { WIDGET } from '@voltmoney/schema';
import { ROUTE } from '../../../routes';
import { Platform } from 'react-native';
import { ACTION } from "./type";
import { goBack, needHelp } from "./action";
import sharedPropsService from "../../../SharedPropsService";
import SharedPropsService from '../../../SharedPropsService';
import { LENDER_ID } from '../../../configs/constants';
export const template = (height, loanExpiryDay, penalInterest, lenderId) => ({
    layout: {
        id: ROUTE.LOAN_RENEWAL_LEARN_MORE_PAGE,
        type: LAYOUTS.LIST,
        style: {
            isPartnerPlatform: true
        },
        widgets: [
            Platform.OS === "ios" ? { id: 'spaceXXL', type: WIDGET.SPACE, position: POSITION.ABSOLUTE_TOP } : {},
            {
                id: "customHeader",
                type: WIDGET.CUSTOM_HEADER,
                position: POSITION.ABSOLUTE_TOP,
            },
            { id: 'loanRenewalLearnMorePage', type: WIDGET.LOAN_RENEWAL_LEARN_MORE_PAGE }
        ],
    },
    datastore: {
        customHeader: {
            // title: "Renew loan",
            needHelpAction: {
                routeId: ROUTE.LOAN_RENEWAL_LEARN_MORE_PAGE,
                type: ACTION.NEED_HELP,
                payload: { id: 'bt_getPortfolioScreen_needHelp_test' }
            },
            goBackAction: {
                routeId: ROUTE.LOAN_RENEWAL_LEARN_MORE_PAGE,
                type: ACTION.GO_BACK,
                payload: { id: 'bt_getPortfolioScreen_goBack_test_12' }
            },
        },
        loanRenewalLearnMorePage: {
            lenderId,
            loanExpiryDay: loanExpiryDay,
            penalInterest: penalInterest,
            height: height - 58,
            ctaAction: {
                type: ACTION.GO_BACK,
                routeId: ROUTE.LOAN_RENEWAL_LEARN_MORE_PAGE,
                payload: {}
            },
        }
        // btnSpace: <SpaceProps>{ size: SizeTypeTokens.XXXL },
    },
});
export const loanRenewalLearnMorePage = {
    onLoad: async ({ network, getHeight }) => {
        const loanExpiryDay = await sharedPropsService.getFirebaseConfig()?.loan_renewal_expiry_days;
        const penalInterestBajaj = await sharedPropsService.getFirebaseConfig()?.loan_renewal_penal_interest;
        const penalInterestTata = await sharedPropsService.getFirebaseConfig()?.loan_renewal_penal_interest_tata;
        const user = await SharedPropsService.getUser();
        const lenderId = user?.linkedApplications[0].lenderAccountId;
        let penalInterest;
        if (lenderId.toLocaleLowerCase() === LENDER_ID.BAJAJ) {
            penalInterest = penalInterestBajaj;
        }
        else
            penalInterest = penalInterestTata;
        return Promise.resolve(template(getHeight(), loanExpiryDay, penalInterest, lenderId));
    },
    actions: {
        [ACTION.GO_BACK]: goBack,
        [ACTION.NEED_HELP]: needHelp,
    },
};
